var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoaInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.086 5.22658H11.6178L9.88372 2.2786C9.5369 1.75837 8.66985 1.75837 8.32303 2.2786L6.58892 5.22658H3.12072C2.42708 5.22658 2.08025 5.92022 2.42708 6.44045L4.16118 9.38843L2.42708 12.3364C2.08025 12.8566 2.42708 13.5503 3.12072 13.5503H6.58892L8.32303 16.4983C8.66985 17.0185 9.5369 17.0185 9.88372 16.4983L11.6178 13.5503H15.086C15.7797 13.5503 16.1265 12.8566 15.7797 12.3364L14.0456 9.38843L15.7797 6.44045C16.2999 5.92022 15.7797 5.22658 15.086 5.22658Z",
    fill: "url(#paint0_linear_493_653)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_653",
    x1: 1.29826,
    y1: -1.96026,
    x2: 14.1879,
    y2: 20.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoaInactiveIcon);
export default __webpack_public_path__ + "static/media/DoaInactiveIcon.2250ba88ce012202de421e5e10df739e.svg";
export { ForwardRef as ReactComponent };